export default {
  setLoading(state, loading) {
    state.loading = loading
  },
  setOffers(state, offers) {
    state.offers = offers.reduce((offers, offer) => ({
      ...offers,
      [offer.id]: offer,
    }), {})
  },
  setOffer(state, offer) {
    const { id } = offer

    state.offers = {
      ...state.offers,
      [id]: offer,
    }
  },
  /**
   * Set current filters
   * @param { Object } state - auto-injected state
   * @param { Object } filters - filters of form { [offerId]: offerFilters }
   */
  setFilters(state, filters) {
    state.filters = { ...state.filters, ...filters }
  },
}
